import { Component, OnInit } from '@angular/core';
import { FormGroup,FormBuilder, Validators  } from '@angular/forms';
import { ApisService } from 'src/app/service/APIs/apis.service';
import { AlertServiceService } from 'src/app/service/alert/alert-service.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-quick-help',
  templateUrl: './quick-help.component.html',
  styleUrls: ['./quick-help.component.scss']
})
export class QuickHelpComponent implements OnInit {

  public contactUsForm: FormGroup | any | undefined;


  baseUrl = environment.baseUrl
  public firstName: any;
  public lastName: any;
  public email: any;
  public subject: any;
  public message: any;

  public isAgree: boolean = false;

  constructor(
    private apiService: ApisService,
    private formBuilder: FormBuilder,
    private alert: AlertServiceService
  ) { }

    /**the method that submit the form for adequate processing */
    submit(){
      this.alert.showLoading();
      if (this.contactUsForm.valid != true) {
        this.alert.errorPop('Invalid Input');
        return;
      }
  
      let data: any = {
        firstName: this.contactUsForm.value.firstName,
        lastName: this.contactUsForm.value.lastName,
        email: this.contactUsForm.value.email,
        phone: this.contactUsForm.value.mobile,
        subject: this.contactUsForm.value.subject,
        message: this.contactUsForm.value.message
      }
      // console.log('data', data);
      
      this.apiService.contactUs(data)
      .subscribe({
        next: (data: any) => {
          // console.log('response', data);
          this.alert.successPop(data?.message);
        },
        error: (err) => {
          console.log("error", err)
          this.alert.errorPop('Error in sending message')
  
        }
      });
    }

    /**whatsapp link */
    whatsApp(){
      setTimeout(() => {
        this.alert.showLoading();
      }, 3000);
      return window.location.assign('https://wa.me/2348037086670');
    }

    /**payment gateway link */
    paymentGateway(){
      setTimeout(() => {
        this.alert.showLoading();
      }, 3000);
      return window.location.assign('https://huiospay-payment-gateway.netlify.app/');
    }

  ngOnInit(): void {
    this.contactUsForm = this.formBuilder.group({
      firstName: ['', [Validators.required]],
      lastName: ['', [Validators.required]],
      mobile: ['', [Validators.required]],
      email: ['', [Validators.required]],
      subject: ['', [Validators.required]],
      message: ['', [Validators.required]],
    });
  }

}
